import { useMemo } from "react";
import { mapMyVendorApiItemsToVendors } from "../utils/myVendorsMapper";
import { useMyVendorsQuery } from "./queries";

/**
 * My Vendors = engaged-with vendors (RFI/VQA activity) ∪ manually-added vendors.
 * Backed by GET /Sponsors/MyVendors/Vendors (ProviderService intraservice aggregation).
 */
export function useMyVendors(sponsorId, vendorTagsMap = {}) {
  const {
    data,
    isLoading,
    isError,
    error,
    refetch,
  } = useMyVendorsQuery(sponsorId);

  const vendors = useMemo(
    () => mapMyVendorApiItemsToVendors(data?.items || [], vendorTagsMap),
    [data?.items, vendorTagsMap]
  );

  const providerIds = useMemo(
    () => (data?.provider_ids || []).map((id) => String(id)),
    [data?.provider_ids]
  );

  const isEmpty = !isLoading && !isError && !!sponsorId && providerIds.length === 0;

  return {
    vendors,
    providerIds,
    engagedProviderIds: (data?.engaged_provider_ids || []).map(String),
    manualProviderIds: (data?.manual_provider_ids || []).map(String),
    hiddenProviderIds: (data?.hidden_provider_ids || []).map(String),
    isLoading,
    isError,
    isEmpty,
    error,
    refetch,
  };
}

export default useMyVendors;
